export default __webpack_public_path__ + "dist/media/SmileyEmoji.6ee09c8e.svg";